import React,{useEffect} from "react";
import "./Modal.css";
import ReactModal from "react-modal-resizable-draggable";
import Grid from "@material-ui/core/Grid";
import { Button,FormHelperText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ClearOutlinedIcon from "@material-ui/icons/ClearOutlined";
import { SelectWidget } from "../widgets/SelectWidget/SelectWidget";
import SectionHeader from "../pages/policyView/components/SectionHeader/SectionHeader";
import { InputLabel } from "../pages/policyView/widgets/InputLabel";
import CustomCheckbox from "../pages/policyView/widgets/CustomCheckbox";
import DateTimeWidget from "../widgets/DateTimeWidget/DateTimeWidget";
import { getModalTop } from "../shared/helpers";
const PrintModal = (props) => {
  const useStyles = makeStyles((theme) => ({
    width100: {
      width: "100%",
    },
    flexItems: {
      display: "flex",
      alignItems: "center",
    },
  }));
  const classes = useStyles();
  const {
    open,
    closeModal,
    formData,
    handleChange,
    handleSubmit,
    isLoading,
    users,
    errorObject,
  } = props;
  useEffect(()=>{
    if(open){
      getModalTop()
    }
  },[open])
  return (
    <ReactModal
      initWidth={500}
      initHeight={150}
            top={"45%"}
            left={"50%"}
            className={"center-modal fixed"}
            onRequestClose={closeModal}
            isOpen={open}
            disableResize={true}
            disableHorizontalMove ={true}
    >
      <div className="modal-title-style">
        <span className="title-modal pl-3">
          <SectionHeader title={"Print"} />
        </span>{" "}
        <span className="close-modal" onClick={closeModal}>
          <ClearOutlinedIcon />
        </span>
      </div>
      <div className="custom-body p-2">
        <div className="modal-root">
          <Grid container className="mb-2">
            <Grid item xs={4} className="text-left">
              <InputLabel value="Diary For" name="Diary For" />
            </Grid>
            <Grid item xs={8} className="text-center" id="userDiaryName">
              <SelectWidget
                id="userNameDiary"
                name="userNameDiary"
                onChange={handleChange}
                fullWidth={true}
                defaultValue={localStorage.getItem("userId")}
                options={users}
              />
            </Grid>
          </Grid>
          <Grid container className="mb-2">
            <Grid item xs={4} className="text-left">
              <CustomCheckbox
                id={"showCleared"}
                name={"showCleared"}
                onChange={handleChange}
                value={formData.showCleared}
              />
              <InputLabel value="Show Cleared" name="Show Cleared" />
            </Grid>
            <Grid item xs={8} className="text-left">
              <CustomCheckbox
                id={"hideImagingDiaries"}
                name={"hideImagingDiaries"}
                onChange={handleChange}
                value={formData.hideImagingDiaries}
              />
              <InputLabel
                value="Hide Imaging Diaries"
                name="Hide Imaging Diaries"
              />
            </Grid>
          </Grid>
          <Grid container className="mb-2">
            <Grid item xs={4} className="text-left">
              <InputLabel value="Date" name="date" />
            </Grid>
            <Grid item xs={8} className="text-center">
              <DateTimeWidget
                id="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                error={errorObject ? errorObject.date : null}
                // helpText={errorObject ? errorObject.date : null}
              />
              {errorObject ? 
              <FormHelperText classes={{ root: "formal-text" }}>
                     {  errorObject.date}
                      </FormHelperText>:null}
            </Grid>
          </Grid>
        </div>
      </div>
      <div className={"modal-custom-footer"}>
        <Grid container spacing={3}>
          <Grid item xs={6} className="text-center"></Grid>
          <Grid item xs={6} className="text-right">
            <Button
              variant="outlined"
              className="submit"
              type="button"
              color="primary"
              onClick={closeModal}
            >
              Close
            </Button>
            <Button
              variant="contained"
              className="submit ml-3"
              type="button"
              color="primary"
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {isLoading ? "Printing..." : "Print"}
            </Button>
          </Grid>
        </Grid>
      </div>
    </ReactModal>
  );
};

export default PrintModal;
